/* eslint-disable no-console */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Layout, Main } from '../AdminTeamCreation/styles';
import ActivityCategory from './activityCategories';
import BehaviorCategory from './behaviorCategories';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { fetchChallengeTypeCount, fetWellbeingCategories } from '../../redux/actions';
// import _ from 'lodash';
// import Waiting from '../Waiting';
import {TabBottomLine, TabWrapper, BorderBottom, Heading} from '../RecogntionAdmin/styles'
import { BrandingTabContainer, BrandingTab, CommonButtonBorder } from '../common/commonStyles';
import {AdminCategories, WellnessAddIconBranding, ViewEventIcon} from '../../utils/icons'
import HoverButton from '../common/HoverButton'
import ChallengeSnapShotDriver from "../ChallengeCreationAdmin/Driver/ChallengeSnapShotDriver";
import RecommendedCard from '../CompanyChallengesAdminUpdated/recommendedCard'
import { GetWellnessChallengeCategories, GetFeaturedChallengeLibrary, GetChallengeTypeList, GetFeaturedChallengesLibrary } from '../../redux/constants/apiConstants';
import { toast } from "react-toastify";
import { ChallengesCategoryCard, EventCard, FlexWrapper, NewChampionsCard, NewContentV2, NewVideoPlayer } from './styles';
import Thumbnail from '../Thumbnail';
import { ImageUrl } from '../../utils/constants';
import { fetchApi } from '../../utils/methods';
import { http } from '../../redux/http';
import NewActivityCategories from './NewActivityCategories';
// import { ManagerIconContainer } from '../Manager/styles';
// import parse from 'react-html-parser';
// import { CommonFilterDropdown } from '../common/CommonYearFilter/CommonYearFilter';


class ChallengesCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTabId: 1,

      selectedTab: this.props.history.location && this.props.history.location.query && this.props.history.location.query.isCategory ? 3 : this.props.history.location.query?.isWellnessCategory ? 2 : 1,
      hoverButton: false,
      onHover: -1,
      getFeaturedChallenge:[],
      getChallengeCategory: [],
      activityCategories: null,
      yearOptions : ["2025", "2024", "2023"],
      selectedYear:2025,
      isSuperAdmin: this.props?.allRoles?.some((role) => role.rid === 3),

      //showWalkthrough: false,
    }
    // onProductTourClick = ()=>{
    //   this.setState({ showWalkthrough: true });
    // }
  }


 

  

  componentDidMount() {
    this.props.role === "ADMIN" ? this.fetchActivityCategories() : this.props.fetchChallengeTypeCount();
    this.props.role === "ADMIN" ? this.getFeaturedChallenge():this.getFeaturedChallengev1();
    this.getWellnessChallengeCategory();
    
    //this.setState({ showWalkthrough: this.props.productTourDetails?.product_tour_data?.admin_challenges });
  }


  onEnterMouse = (id) => {
    this.setState({
      onHover: id,
    });
  };

  

  onLeaveMouse = () => {
    this.setState({
      onHover: -1,
    });
  };


  getFeaturedChallengev1 = async () =>{
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    const { companyId } = this.props;
    try {
      const res = await http.get(`${GetFeaturedChallengesLibrary}/${companyId}`, {headers: {AUTHTOKEN: AuthToken}});
      if (res.message) {
        toast.error(res.message);
      }else{
        this.setState({
          getFeaturedChallenge:res
        })
      }
    }catch(error){
      toast.error(error.message);
    }
  }

  getFeaturedChallenge = async () => {
    const { companyId } = this.props;
    try {
      const res = await fetchApi(`${GetFeaturedChallengeLibrary}?company_id=${companyId}`, 'GET');
      if (res.statusCode === 200) {
        this.setState({ getFeaturedChallenge: res.data || [] });
      } else {
        toast.error(res.message);
      }
    } catch(error) {
      toast.error(error.message);
    }
  }

  getWellnessChallengeCategory = async()=>{
    let apiUrl = GetWellnessChallengeCategories;
    try{
      const res = await fetchApi(apiUrl, "GET");
      if(res.status === "success"){
        this.setState({
          getChallengeCategory:res.data
        })

      }else{
        toast.error(res.message);
      }
    }catch(error){
      toast.error(error)
    }
  }

  fetchActivityCategories = async () => {
    try {
      const res = await fetchApi(`${GetChallengeTypeList}?language_id=1`, 'GET');
      if (res.statusCode === 200) {
        this.setState({ activityCategories: res.data || [] });
      } else {
        toast.error(res.message);
      }
    } catch(error) {
      toast.error(error.message);
    }
  }

  redirection = () => {
    const { history } = this.props;
    history.push('/company/challenges/create-activty')
  };

  showPastEvents = (path) => {
    this.props.history.push(path);
  };

  onCloseTab = (value) => {
    this.setState({
      selectedTab: value,
      selectedTabId: value + 1,
    });
    if(value===3){
      this.props.fetWellbeingCategories()
    }
  };

  selectYearData = (value) => {
    this.setState({selectedYear: value});
  }

  onHover = (value) => {
    this.setState({
      hoverButton: value
    })
  };

  recommended = [
    { 
      title: "Morning Yoga", 
      id: 1, 
      color: "#E4888C", 
      backgroundColor: "#EFEFEF", 
      description: "Start your day with a refreshing yoga session. Learn the benefits of a balanced diet. Learn the benefits of a balanced diet. Learn the benefits of a balanced diet.", 
      category_name: "wellness",
      image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
      thumbnail_image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
    },
    { 
      title: "Healthy Eating", 
      id: 2, 
      color: "#88C0E4", 
      backgroundColor: "#F0F8FF", 
      description: "Learn the benefits of a balanced diet. Start your day with a refreshing yoga session. Start your day with a refreshing yoga session. Start your day with a refreshing yoga session.", 
      category_name: "nutrition",
      image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
      thumbnail_image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
    },
    { 
      title: "Mindfulness Meditation", 
      id: 3, 
      color: "#A3D9A5", 
      backgroundColor: "#EAFBEA", 
      description: "Practice mindfulness to reduce stress and increase focus. Learn the benefits of a balanced diet. Learn the benefits of a balanced diet. Learn the benefits of a balanced diet", 
      category_name: "mental health",
      image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
      thumbnail_image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
    },
    { 
      title: "Strength Training", 
      id: 4, 
      color: "#FFB347", 
      backgroundColor: "#FFF5E1", 
      description: "Build muscle and improve endurance with strength exercises. Practice mindfulness to reduce stress and increase focus. Practice mindfulness to reduce stress and increase focus. Practice mindfulness to reduce stress and increase focus", 
      category_name: "fitness",
      image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
      thumbnail_image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
    },
    { 
      title: "Hydration Tips", 
      id: 5, 
      color: "#6495ED", 
      backgroundColor: "#E6ECF7", 
      description: "Stay hydrated for better health and performance. Build muscle and improve endurance with strength exercises. Build muscle and improve endurance with strength exercises. Build muscle and improve endurance with strength exercises", 
      category_name: "wellness",
      image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
      thumbnail_image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
    }
  ];

  render() {
    const { history, activityChallengeType, wellbeingCategoriesData, role, t,brandingColor } = this.props;
    const { selectedTab, getFeaturedChallenge,onHover,getChallengeCategory,/*yearOptions,selectedYear*/isSuperAdmin, activityCategories } = this.state;
    // if (_.isNull(activityChallengeType)|| _.isUndefined(activityChallengeType)) {
    //   return <Waiting />
    // }
    // let getColor = "rgba(243, 122, 101, 1)"



    let getColor = brandingColor ? brandingColor : "rgba(243, 122, 101, 1)"
    return (
      <Layout>
        <ChallengeSnapShotDriver
          activeTabId={this.state.selectedTabId}
          setTab={(tabId) => this.setState({ selectedTabId: tabId })} 
        />

        <Main>
          {
            <BrandingTabContainer isCompare={"0px"}>
              <div className='wrapper'>
                <BrandingTab background={getColor ? getColor : "#0b4170"} active={false} onClick={() => this.showPastEvents(history.location.pathname.includes("/company/challenges/")?'/company/challenges':'/challenges')}>
                  Dashboard
                </BrandingTab>
                <BrandingTab background={getColor ? getColor : "#0b4170"} active={false} onClick={() => this.showPastEvents(history.location.pathname.includes("/company/challenges/")?'/company/challenges/completed':'/challenges/completed')}>
                  Completed
                </BrandingTab>
                <BrandingTab background={getColor ? getColor : "#0b4170"} active={true} >
                  Library
                </BrandingTab>
              </div>
                
              <div className='rightSection'>
                {role=="ADMIN"&&<div className='compare'>
                  <HoverButton
                    title={  selectedTab === 1 ? "Create Activity Challenge" : selectedTab === 2 ? "Create Journey Category" :  selectedTab === 3 ? "Create Wellness Challenge" : "Create Challenge"} svgPath={<WellnessAddIconBranding/>}
                    activeColor={"#DA6C74"}
                    inActiveColor={"#DA6C74"}
                    backgroundColor={"white"}
                    backgroundColorActive={"#DA6C74"}
                    onClick={
                      selectedTab === 1
                        ? history.location.pathname.includes("/company/challenges/categories")
                          ? () => history.push('/company/challenges/create-activty')
                          : () => history.push('/challenges/create-activty')
                        : selectedTab === 2
                          ? () => history.push('/company/challenges/create-challenge-category') // 👈 Added this for tab 2
                          : history.location.pathname.includes("/company/challenges/categories")
                            ? () => history.push('/company/challenges/create-behavior')
                            : () => history.push('/challenges/create-behavior')
                    }
                    // onClick={selectedTab===1?history.location.pathname.includes("/company/challenges/categories")?() => history.push('/company/challenges/create-activty'):() => history.push('/challenges/create-activty'):history.location.pathname.includes("/company/challenges/categories")?() => history.push('/company/challenges/create-behavior'):() => history.push('/challenges/create-behavior') }
                    width={"20px"}
                    height={"20px"}
                    fillOpacity={1}
                  />
                </div>}
              </div>
              {/* <div style={{marginLeft:"16px"}}>
                <CommonFilterDropdown
                  options={yearOptions}
                  selectedOption={selectedYear}
                  setSelectedOption={this.selectYearData}
                  dropdownHeight={"auto"}
                />
              </div> */}

             
            </BrandingTabContainer>
          }
          <TabWrapper>
            <TabBottomLine id="activitysubtab" active={selectedTab===1} background={getColor} onClick={() => this.onCloseTab(1)}>
              {t("Activity")}
              <BorderBottom active={selectedTab===1} background={getColor} />
            </TabBottomLine>

            {isSuperAdmin ? <TabBottomLine id="wellnesssubtab" active={selectedTab===2} background={getColor} onClick={() => this.onCloseTab(2)}>
              {/* {t("Wellness")} */}
              {t("Journey")}
              <BorderBottom active={selectedTab===2} background={getColor} />
            </TabBottomLine> : null}

            <TabBottomLine id="legacysubtab" active={selectedTab===3} background={getColor} onClick={() => this.onCloseTab(3)}>
              {t("Wellness Challenge")}
              <BorderBottom active={selectedTab===3} background={getColor} />
            </TabBottomLine>
          </TabWrapper>
          {selectedTab===1 && getFeaturedChallenge?.length>0?<RecommendedCard
            RecommendedEventData={getFeaturedChallenge}
            margin="0px"
            isActivity="1"
            history={history}
            RecommendedEventDataLoading={false}
          />:null}
          {selectedTab===1 ? <Heading isMargin={"20px 0px 20px 0px"}>
            <div className='icon'>
              {AdminCategories("#184A61")}
            </div>
              Explore Categories
          </Heading>:null}

          {selectedTab===1 ? role === 'ADMIN'?<NewActivityCategories history={history} activityChallengeType={activityCategories} role={role}/> : <ActivityCategory history={history} activityChallengeType={activityChallengeType} role={role}/> :
            selectedTab===3 ? 
              <BehaviorCategory history={history} wellbeingCategoriesData={wellbeingCategoriesData.slice(0, 6)} role={role}/> : null}
         

          {selectedTab === 2 ?<FlexWrapper>
            {getChallengeCategory?.length > 0 ? getChallengeCategory.map((item, index) => (
              <NewChampionsCard key={index}>
                <EventCard isMarginBottom={"0px"} onMouseEnter={() => this.onEnterMouse(index)} onMouseLeave={() => this.onLeaveMouse()}>
                  <NewVideoPlayer>
                    <Thumbnail
                      //  onClick={()=>upComingEventsRedirection(item?.id)}
                      style={{ cursor: 'default' }}
                      src={`${ImageUrl}/${item?.image}`}
                      alt={'img'}
                    />
                  </NewVideoPlayer>
                  {onHover === index &&
                     <div className='educateImageBackground' onClick={() => history.push({pathname: `/company/challenges/challenge-category/${item?.id}`, state : {description: item}})}>
                       <div className="getStarted">
                         {ViewEventIcon()}
                         {t("View Category")}
                       </div>
                     </div>
                  }
                  <NewContentV2 newPadding={'newPadding'} style={{ minHeight: 'auto' }} isMargin={"0px"}>
                    <div className='firstContainer' style={{display:"flex", justifyContent:"space-between",alignItems:"center"}}>
                      <div style={{display:"flex",flexDirection:"column"}}>
                        <div className='name' title={item?.category_name}>
                          {item?.category_name}
                        </div>
                        {/* <div className='categoryName' title={item?.description}>
                          {parse(item?.description)}
                        </div>  */}
                      </div>
                      <div className={"monthName"}>{item?.month_name || "" }</div>

                      {/* <ManagerIconContainer  onClick={() => history.push({pathname: `/company/challenges/edit-wellness-category/${item?.id}`, state : {categoryData: item}})}>
                        {EditIconBranding()}
                      </ManagerIconContainer> */}
                    </div>
                  </NewContentV2>
                </EventCard>
              </NewChampionsCard> )):null }
            {/* <NewChampionsCard>
                <EventCard   onMouseEnter={() => this.onEnterMouse(1)} onMouseLeave={() => this.onLeaveMouse()}>
                  <NewVideoPlayer>
                    <Thumbnail
                      //  onClick={()=>upComingEventsRedirection(item?.id)} 
                      style={{ cursor: 'default' }} 
                      src={`${ImageUrl}/plg/${'confirmation.png'}`}
                      //  src={`${ImageUrl}/${item?.thumbnail_image}`}
                      alt={'img'}
                    />
                  </NewVideoPlayer>
                  {onHover === 1 &&
                     <div className='educateImageBackground' onClick={() => history.push(`/company/challenges/wellneschallenge-category`)}>
                       <div className="getStarted">
                         {ViewEventIcon()}
                         {t("View Category")} 
                       </div>
                     </div>
                  }
                  <NewContentV2 newPadding={'newPadding'} style={{ minHeight: 'auto' }}>
                    <div className='firstContainer'>
                      <div className='name' title={"Happy Awesomeness Day"}>
                       Awesome Day
                      </div>
                    </div>
                  </NewContentV2>
                </EventCard>
              </NewChampionsCard> */}
          
            <ChallengesCategoryCard>
              <CommonButtonBorder width="200px" height="48px"
                onClick={() => history.push(`/company/challenges/create-challenge-category`)}
                margin="auto auto auto 0px">
                {WellnessAddIconBranding()}
                Create Category 
              </CommonButtonBorder>
            </ChallengesCategoryCard>
           
          </FlexWrapper>: null}
        
        </Main>
      </Layout>
    );
  }
}

ChallengesCategory.propTypes = {
  history: PropTypes.object,
  role: PropTypes.string,
  fetchChallengeTypeCount: PropTypes.func,
  activityChallengeType: PropTypes.array,
  fetWellbeingCategories: PropTypes.func,
  wellbeingCategoriesData: PropTypes.array,
  t: PropTypes.func,
  brandingColor:PropTypes.string,
  companyId:PropTypes.number,
  allRoles: PropTypes.array,
  //productTourDetails:PropTypes.object,
};

const mapStateToProps = (state) => ({
  activityChallengeType: state.challenges.activityChallengeType,
  wellbeingCategoriesData: state.adminReports.wellbeingCategoriesData,
  brandingColor:state.wellnessDashboard.brandingColor,
  allRoles: state.profileData.allRoles,
  //productTourDetails: state.profileData.productTourDetails,
})

const mapDispatchToProps = (dispatch) => ({
  fetchChallengeTypeCount: () => dispatch(fetchChallengeTypeCount()),
  fetWellbeingCategories: () => dispatch(fetWellbeingCategories())
})  

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ChallengesCategory));
